"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      font-size: 48px;\n      line-height: 56px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n\n    font-weight: ", ";\n    font-size: 26px;\n    line-height: 32px;\n    text-align: ", ";\n\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var textCommon_1 = require("../textCommon");

var H3 = styled_components_1["default"].h3(_templateObject(), textCommon_1.headingCommon, function (_ref) {
  var theme = _ref.theme,
      contrast = _ref.contrast,
      thin = _ref.thin,
      align = _ref.align;
  return styled_components_1.css(_templateObject2(), contrast ? theme.palette.text.contrast : bitcoincom_pkg_theme_1.colors.solid.textOne, thin ? 500 : 700, align, bitcoincom_pkg_theme_1.media.md(_templateObject3()));
});
exports["default"] = H3;